module.exports = __webpack_public_path__ + "static/media/ubt.96c9873f.png";